import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketSchedulesEventSubscription = () => {
  // Invalidate schedules for the entity when a schedule is created, updated or deleted
  return useWebsocketEventSubscription(NotificationType.SCHEDULE_CHANGED, () => {
    // const entityId = payload.params.changeType === 'PROVIDER' ? payload.params.providerId : payload.params.locationId;
    // TODO: check with backend around this whether this is still used for V3 schedule defintion case
    // Also we need to ask/check how V2 handled in this case.
  });
};
